import axios from "axios";

export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY_PROD;

const axiosMainInstance = axios.create({
  baseURL: "https://api.mtor.online",
});

axiosMainInstance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosMainInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response } = error;
    const { status } = response || {};
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      window.location.reload();
    }

    return Promise.reject(error);
  }
);
export default axiosMainInstance;
